import CloudUploadRoundedIcon from '@mui/icons-material/CloudUploadRounded';
import { Button, Tooltip } from '@mui/material';
import { ChangeEvent, RefObject } from 'react';

interface FileImportButtonProps {
  disabled: boolean;
  tooltipTitle: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  inputRef: RefObject<HTMLInputElement>;
}

export const FileImportButton = ({
  disabled,
  tooltipTitle,
  onChange,
  inputRef,
}: FileImportButtonProps) => {
  const handleButtonClick = () => {
    inputRef.current?.click();
  };

  return (
    <Tooltip title={tooltipTitle}>
      <span>
        <Button
          disabled={disabled}
          startIcon={<CloudUploadRoundedIcon />}
          variant="outlined"
          size="small"
          onClick={handleButtonClick}
          sx={{
            backgroundColor: '#fff'
          }}
        >
            インポート
          <input
            type="file"
            disabled={disabled}
            onChange={onChange}
            ref={inputRef}
            accept="text/csv"
            style={{
              opacity: 0,
              width: '0',
              height: '0',
            }}
          />
        </Button>
      </span>
    </Tooltip>
  );
};

